const WHATSAPP_URL = 'https://wa.me/5519988179126?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20visita%20%C3%A0%20Escola%20Turminha%20da%20Alegria.';
const WHATSAPP_CONTATO = 'https://wa.me/5519988179126';

export default function CTAPrincipal() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20Brazilian%20school%20courtyard%20with%20colorful%20flowers%20children%20playing%20in%20background%20warm%20golden%20sunset%20light%20vibrant%20colors%20joyful%20school%20environment%20wide%20angle%20blurred%20soft%20bokeh%20background&width=1440&height=600&seq=cta1&orientation=landscape"
          alt="Escola Infantil Turminha da Alegria – ambiente escolar"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-azul-escuro/90 via-azul-escuro/80 to-azul-medio/70" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <span className="inline-block bg-white/20 text-white font-body font-700 text-sm px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
          Agende uma visita
        </span>
        <h4 id="cta-principal">
          <a className="font-heading text-white text-3xl lg:text-5xl leading-tight block mb-6">
            Venha conhecer a escola que vai<br />
            <span className="text-azul-claro">transformar</span> a vida do seu filho
          </a>
        </h4>
        <p className="font-body text-white/85 text-base lg:text-lg mb-10 max-w-2xl mx-auto">
          Agende uma visita presencial e conheça nossas instalações, nossa equipe e a metodologia que faz da Turminha da Alegria uma escola única em Campinas.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-vermelho text-white font-body font-700 text-base px-8 py-4 rounded-full hover:bg-red-600 hover:scale-105 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-whatsapp-line text-xl" />
            Falar no WhatsApp
          </a>
          <a
            href={WHATSAPP_CONTATO}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-white text-azul-escuro font-body font-700 text-base px-8 py-4 rounded-full hover:bg-cinza hover:scale-105 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-line text-xl" />
            Agendar Visita
          </a>
        </div>
      </div>
    </section>
  );
}
